import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import app from "./modules/app";
import session from "./modules/session";
import account from "./modules/account";
import billing from "./modules/billing";
import user from "./modules/user";
import role from "./modules/role";
import tenant from "./modules/tenant";

const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {},
  modules: {
    app,
    session,
    account,
    billing,
    user,
    role,
    tenant
  }
});

export default store;
